import { useState } from "react";
import tools from "../../../helpers/tools";
import { nomDeTache } from "../TodoList/resumeTaches";
import Compteur from "./Compteur";
import { basculerEpingle, indexProchaineTache, indexTacheAffichee, libelleSegment, nbTachesFaites } from "./tachesResume";
import TitreZone from "./TitreZone";

// Tâches : une barre de segments (un par tâche, dans l'ordre) et la tâche
// détaillée en dessous. Par défaut c'est la prochaine à faire ; survoler ou
// prendre le focus sur un segment montre sa tâche, un clic l'épingle (elle
// reste affichée quand la souris part), un second clic la désépingle. La case
// à cocher fait et défait la tâche affichée, y compris une tâche déjà faite
// (PER-2446, PER-2447). `onBasculer` reçoit la tâche avec son nouvel état.
// Le nom d'une tâche vient du catalogue du produit (`catalogue`) quand la
// tâche ne porte que son identifiant, comme sur les leads entreprise et DOMI.
const ZoneTaches = ({ taches: tachesBrutes = [], catalogue = [], onBasculer, ouvrir }) => {
  const [survolee, setSurvolee] = useState(null);
  const [epinglee, setEpinglee] = useState(null);
  const taches = tachesBrutes.map((t) => ({ ...t, name: nomDeTache(catalogue, t) }));
  const total = taches.length;
  const faites = nbTachesFaites(taches);
  const prochaine = indexProchaineTache(taches);
  const affichee = indexTacheAffichee(taches, { survolee, epinglee });
  const tache = affichee >= 0 ? taches[affichee] : null;

  const etiquette =
    affichee === -1
      ? ""
      : affichee === epinglee && survolee === null
        ? "Tâche épinglée"
        : affichee === prochaine
          ? "Prochaine tâche"
          : "Tâche";

  const basculer = () => onBasculer({ ...tache, isDone: !tache.isDone });

  const detail = (t) =>
    t.isDone
      ? `Faite${t.updatedBy ? ` par ${t.updatedBy}` : ""}${t.updatedAt ? ` le ${tools.formatDateHours(t.updatedAt)}` : ""}`
      : `Créée par ${t.createdBy || "Perceval"}${t.createdAt ? ` le ${tools.formatDateHours(t.createdAt)}` : ""}`;

  return (
    <section className="la-zone" aria-label="Tâches" onMouseLeave={() => setSurvolee(null)}>
      <TitreZone icone="fa-tasks" onglet="taches" ouvrir={ouvrir}>
        Tâches{" "}
        <Compteur plein={faites > 0}>
          {faites}/{total}
        </Compteur>
      </TitreZone>
      {total > 0 && (
        <div className="la-segments" role="group" aria-label={`${faites} tâches faites sur ${total}`}>
          {taches.map((t, i) => (
            <button
              key={t.id}
              type="button"
              className={[
                "la-segment",
                t.isDone ? "la-segment--faite" : "",
                i === prochaine ? "la-segment--prochaine" : "",
                i === epinglee ? "la-segment--epinglee" : "",
                i === affichee ? "la-segment--affichee" : "",
              ]
                .filter(Boolean)
                .join(" ")}
              aria-label={libelleSegment(t, i, total)}
              aria-pressed={i === epinglee}
              title={libelleSegment(t, i, total)}
              onMouseEnter={() => setSurvolee(i)}
              onFocus={() => setSurvolee(i)}
              onBlur={() => setSurvolee(null)}
              onClick={() => setEpinglee((valeur) => basculerEpingle(valeur, i))}
            />
          ))}
        </div>
      )}
      {tache ? (
        <>
          <div className="la-tache__etiquette">
            {etiquette} ({affichee + 1}/{total})
          </div>
          <label className="la-case">
            <input type="checkbox" checked={Boolean(tache.isDone)} onChange={basculer} />
            <span>
              {tache.name}
              <span className="la-case__meta">{detail(tache)}</span>
            </span>
          </label>
        </>
      ) : total > 0 ? (
        <div className="la-toutes-faites">
          <i className="fa fa-check-circle" aria-hidden="true" />
          Toutes les tâches sont faites
        </div>
      ) : (
        <p className="la-aucun">Aucune tâche.</p>
      )}
    </section>
  );
};

export default ZoneTaches;
